export function calculateSaldoPendiente(precio, depositAmount, depositStatus) {
  const price = Number(precio) || 0;
  const deposit = depositStatus === 'confirmed' ? (Number(depositAmount) || 0) : 0;
  return Math.max(0, price - deposit);
}
